// extracted by mini-css-extract-plugin
export default {"departments":"XE-z","departmentHeading":"YE-z","departmentSection":"ZE-z","departmentName":"_E-z","departmentLink":"aF-z","expandIcon":"bF-z"};